module.exports = __webpack_public_path__ + "img/person.72093297.svg";